import { environment } from "src/environments/environment";
import { UserService } from "./../../UserManagement/userService/api/user.service";
import { SubjectService } from "./../../common/services/subject.service";
import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionService } from "src/app/common/services/session.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
})
export class FooterComponent implements OnInit {
  supportedLang: any[];
  appVersion: "";
  constructor(
    public translate: TranslateService,
    private subService: SubjectService,
    private userSrvice: UserService,
    private ss: SessionService
  ) {}

  ngOnInit() {
    this.getSupportedlang();
    let instanceConfig = this.ss.getInstanceConfig();
    this.appVersion = instanceConfig.UI_VERSION;
  }

  changeLangEvent(selectedLang) {
    this.translate.use(selectedLang);
    localStorage.setItem("selectedLang", selectedLang);
    this.subService.selectedLang.next(selectedLang);
  }

  getSupportedlang() {
    this.userSrvice.getSupportedLang().subscribe(
      (res: any) => {
        this.supportedLang = res[0];
      },
      (err: any) => console.log(err)
    );
  }
}
